import { EntityState, Update, createEntityAdapter } from '@ngrx/entity';
import { tableFilterTypes, performerActions } from './performers.era';
import { ExhibitorStand } from 'globals/store/exhibitors.data';
import { Ranking } from 'globals/store/events.data';
import { makeMapFromListOfObjectsAndKey } from 'globals/helpers/helpers';
import { eventsActions } from './events.era';
import { createFeature, createFeatureSelector, createReducer, on } from '@ngrx/store';

export interface ExhibitorStandsState extends EntityState<ExhibitorStand> {
  exhibitorFilterType: string
  standTypes: { [id:string]: Ranking }
}

const getDefaultExhibitorsState = ():ExhibitorStandsState => ({
  ids: [],
  entities: {},
  exhibitorFilterType: tableFilterTypes.NoFilters,
  standTypes: {}
})

export const adapter = createEntityAdapter<ExhibitorStand>()
export const makeInitialState = (): ExhibitorStandsState => adapter.getInitialState(getDefaultExhibitorsState())

// Reducers

export const exhibitorsStandsReducer = createReducer(
  makeInitialState(),
  on(eventsActions.loadEvent, (state, { payload }) => {
    const changedState = adapter.upsertMany(Object.values(payload.exhibitorStands), state)
    const newState = { ...changedState }
    newState.standTypes = !payload.standTypes ? {} : makeMapFromListOfObjectsAndKey(payload.standTypes, 'id')
    return newState
  }),
  on(eventsActions.unloadEvent, (state) => ({ ...makeInitialState() })),
  on(performerActions.changeTableFilters, (state, { filterType }) => ({ ...state, exhibitorFilterType: filterType })) 
)

export const exhibitorStandsFeature = createFeature({
  name: 'exhibitorStands',
  reducer: exhibitorsStandsReducer,
});

export const exhibitorStandsStateSelector = createFeatureSelector<ExhibitorStandsState>(exhibitorStandsFeature.name)